import { render } from "./PromoTestCardWithCheckbox.vue?vue&type=template&id=468f100b&scoped=true"
import script from "./PromoTestCardWithCheckbox.vue?vue&type=script&lang=js"
export * from "./PromoTestCardWithCheckbox.vue?vue&type=script&lang=js"

import "./PromoTestCardWithCheckbox.vue?vue&type=style&index=0&id=468f100b&scoped=true&lang=css"
import "./PromoTestCardWithCheckbox.vue?vue&type=style&index=1&id=468f100b&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-468f100b"]])

export default __exports__